import {createSlice} from '@reduxjs/toolkit';
import {
    getComparativeSnapshotData,
    setMicroclimateKey,
} from './comparative-snapshot-actions';
import {Microclimates} from 'api/rates/comparative-snapshot/comparative-snapshot.types';
import {MICROCLIMATES} from 'pages/rates/comparative-snapshot/utils';
export interface ComparativeSnapshotState {
    microclimates: Microclimates;
    microclimateKey: string;
    isLoading: boolean;
}
export const initialState: ComparativeSnapshotState = {
    microclimates: {
        radius025: null,
        radius05: null,
        radius10: null,
    },
    microclimateKey: Object.keys(MICROCLIMATES)[0],
    isLoading: false,
};

const comparativeSnapshotSlice = createSlice({
    name: 'comparativeSnapshot',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(setMicroclimateKey, (state, {payload}) => {
                state.microclimateKey = payload;
            })
            .addCase(
                getComparativeSnapshotData.fulfilled,
                (state, {payload}) => {
                    state.microclimates = payload;
                    state.isLoading = false;
                }
            )
            .addCase(getComparativeSnapshotData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getComparativeSnapshotData.rejected, (state, action) => {
                state.microclimates = initialState.microclimates;
                if (action.meta.aborted) {
                    return;
                }

                state.isLoading = false;
            });
    },
});

export default comparativeSnapshotSlice.reducer;
